import React from "react";
import { useLang } from "@/context/LangContext";
import { Check } from "lucide-react";

const About = () => {
  const { t } = useLang();
  return (
    <section id="about" className="py-24 md:py-32 relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <p className="overline">{t.about.overline}</p>
          <h2 className="display mt-5 text-4xl md:text-5xl lg:text-6xl text-[#1A0010] whitespace-pre-line">
            {t.about.title}
          </h2>
          <div className="hairline-strong w-20 mt-8" />
          <img
            src="https://images.unsplash.com/photo-1589578527966-fdac0f44566c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxzY2FsZXMlMjBvZiUyMGp1c3RpY2UlMjBicmFzc3xlbnwwfHx8fDE3ODEyODc0MzB8MA&ixlib=rb-4.1.0&q=85"
            alt="Justice"
            className="editorial-img mt-10 w-full h-[320px] object-cover hidden lg:block"
          />
        </div>

        <div className="lg:col-span-7 lg:pt-14">
          <p className="serif text-xl md:text-2xl text-[#1A0010] leading-relaxed font-light">
            {t.about.paragraph1}
          </p>
          <p className="mt-6 text-[15px] md:text-base text-[#4D3D46] leading-relaxed">
            {t.about.paragraph2}
          </p>

          <ul className="mt-10 space-y-4">
            {t.about.bullets.map((b, i) => (
              <li key={i} className="flex items-start gap-4 pb-3 border-b border-[#D4AF37]/25">
                <span className="mt-1 text-[#66023C]">
                  <Check size={16} strokeWidth={1.5} />
                </span>
                <span className="serif text-lg md:text-xl text-[#1A0010] font-light">
                  {b}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
